import React, { useState } from "react";
import axios from "axios";
import { ApiUrl } from '../Constants/Weburl'
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import DeleteModal from "./DeleteModal";

export default function AddGiftModal({ close, refresh, editGift }) {
  const [gif, setGif] = useState(null);
  const [coins, setCoins] = useState(editGift ? editGift.coins : "");
  

  


  const uploadGift = async () => {
    if (!coins) {
      alert("Coins required");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("coins", coins);

      if (gif) {
        formData.append("gif", gif);
      }

      let res;

      if (editGift) {
        res = await axios.put(
          `${ApiUrl}api/gifts/${editGift.id}`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
      } else {
        res = await axios.post(
          `${ApiUrl}api/gifts`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );
      }

      // alert(res.data.message || "Success");
      refresh();
      close();

    } catch (err) {
      console.error(err);
      alert("Operation failed");
    }
  };
  return (
    // <div 
    // className="modal-backdrop"
    // >
    <Modal
      show={true}
      onHide={close}
      centered
      className="hashtag-add-modal"
    >
      {/* <div className="modal-box"> */}
      {/* <h3>Add Gift</h3> */}
      {/* <h3>{editGift ? "Edit Gift" : "Add Gift"}</h3> */}
      <Modal.Header
        // closeButton
        className="hashtag-modal-header"
      >
        <Modal.Title>
          {editGift ? "Edit Gift" : "Add Gift"}
        </Modal.Title>

        <button
          type="button"
          className="hashtag-close-btn"
           onClick={close}
          // onClick={() => setShowModal(false)}
        >
          ×
        </button>

      </Modal.Header>

      <Modal.Body className="hashtag-modal-body">


        <Form.Group>

          <Form.Label className="profile-pill">Image</Form.Label>
          <Form.Control
            type="file"
            accept="image/gif"
            onChange={(e) => setGif(e.target.files[0])}
            className="gift-file-input"
          />

        </Form.Group>


        <Form.Group >
          <Form.Label className="profile-pill">Coins</Form.Label>
          <Form.Control
            type="number"
            placeholder="Coins"
            value={coins}
            onChange={(e) => setCoins(e.target.value)}
          />
        </Form.Group>

      </Modal.Body>

      <Modal.Footer className="hashtag-modal-footer">

        {/* <div className="modal-actions"> */}
        {/* <button onClick={uploadGift}>Upload</button> */}
        <Button
          variant="secondary"

          onClick={uploadGift}
           className="hashtag-save-btn"
           
        >
          {editGift ? "Update" : "Save"}
        </Button>
        <Button
          // className="cancel"
          variant="secondary"
          className="hashtag-close-footer-btn"
          onClick={close}
        >Close</Button>
        {/* </div> */}

      </Modal.Footer>
      {/* </div> */}
      {/* </div> */}
    </Modal>
  );
}
